<app-top-bar></app-top-bar>
<ion-content>
    <div class="main-header">
        <span>Delivery Status</span>
        <div (click)="navigateBack()" class="back-button-mobile">
            <ion-icon name="chevron-back-outline"></ion-icon>
        </div>
    </div>
    <div class="mobile-info">
        <ion-grid class="info-grid">
            <ion-row class="row">
                <span class="top-header-label">Cust:</span>
                <div *ngIf="loaded">{{garmentSummary.employeeListing.customerCode}} {{garmentSummary.employeeListing.customerName}}
                </div>
            </ion-row>
            <ion-row class="row">
                <span class="top-header-label">Stop:</span> <ng-container *ngIf="loaded">{{garmentSummary.employeeListing.stopCode}}
                    {{garmentSummary.employeeListing.stopName}}</ng-container>
            </ion-row>
            <ion-row class="bottom-row">
                <span class="top-header-label">Locker:</span> <ng-container *ngIf="loaded">{{garmentSummary.employeeListing.employeeCode}} <h6>
                    {{garmentSummary.employeeListing.lastName}}, {{garmentSummary.employeeListing.firstName}}</h6></ng-container>
            </ion-row>
        </ion-grid>
    </div>

    <div *ngIf="loaded" class="content">
        <a [routerLink]="'garment-detail'">Click to view garment detail</a>
        <ion-grid class="products-detail">
            <ion-row class="products-title">
                Products Detail
            </ion-row>
            <ion-row class="products-header">
                <ion-col size="7.4" class="products-header-top">Product</ion-col>
                <ion-col size="2.6" class="products-header-row">Quantity</ion-col>
                <ion-col size="2" class="products-header-row">Size</ion-col>
            </ion-row>
            <ion-row *ngFor="let detail of garmentSummary.details" (click)="expandItem(detail)" class="products-details">
                <ion-col size="7.4" class="add-sign products-details-titles-top">
                    <div *ngIf="!detail.expanded" class="add-sign-content">
                        <ion-icon name="add-outline"></ion-icon>
                    </div>
                    <div *ngIf="detail.expanded" class="add-sign-content">
                        <ion-icon name="remove-outline"></ion-icon>
                    </div>
                    {{detail.productCode}}
                </ion-col>
                <ion-col size="2.6" class="products-details-titles">{{detail.inventory}}</ion-col>
                <ion-col size="2" class="products-details-titles">{{detail.size1}}-{{detail.size2}}</ion-col>
                <ion-row class="expanded-parent">
                    <div *ngIf="detail.expanded" class="expanded-content">
                        <ion-row>
                            <span><span class="bold-text">Product Description: </span> {{detail.name}}</span>
                        </ion-row>
                    </div>
                </ion-row>
            </ion-row>
        </ion-grid>
        <ion-grid class="weekly-detail">
            <ion-row class="weekly-title">
                Weekly Detail
            </ion-row>
        
            <ng-container *ngIf="loaded && (!garmentHistory || garmentHistory.length > 0)">
                <ion-row class="weekly-header">
                    <ion-col  class='weekly-row' *ngFor="let column of WeeklyColumns">{{ column === 'StatusDate' ? 'Week Of' : column }}</ion-col>
                </ion-row>
        
                <ng-container *ngIf="garmentHistory.length > 0">
                    <ion-row *ngFor="let weeks of garmentHistory.slice(0, 1)" class="this-week">
                        <ion-col class="past-weeks-right" *ngFor="let column of WeeklyColumns">
                            <span *ngIf="isDate(weeks[column])">This Week</span>
                            <span *ngIf="!isDate(weeks[column])">{{ weeks[column] }}</span>
                        </ion-col>
                    </ion-row>
        
                    <ion-row class="past-week-header">
                        <ion-col class="past-weekly-row">Past Weeks</ion-col>
                    </ion-row>
        
                    <ion-row *ngFor="let weeks of garmentHistory | slice: 1" class="past-weeks">
                        <ion-col class="past-weeks-right" *ngFor="let column of WeeklyColumns">
                            <span *ngIf="isDate(weeks[column])">{{ weeks[column] | date: 'MM-dd-yyyy' }}</span>
                            <span *ngIf="!isDate(weeks[column])">{{ weeks[column] }}</span>
                        </ion-col>
                    </ion-row>
                </ng-container>
            </ng-container>
        
            <ion-row class="no-data" *ngIf="loaded && (!garmentHistory || garmentHistory.length <= 0)">
                <ion-col>
                    <div>
                        <span>No Data Found</span>
                    </div>
                </ion-col>
            </ion-row>
        </ion-grid>
        
    </div>
    <div class="spin" *ngIf="!loaded">
        <ion-spinner name="circular"></ion-spinner>
    </div>
</ion-content>
<app-footer></app-footer>